module.exports = __webpack_public_path__ + "static/media/lo12.4065e597.png";